
export enum AwardDocumentAcceptanceType {
    None,
    AcceptTermsAndConditions,
    DocumentUpload,
}